<template>
  <div class="c-video">
    <div class="c-thumb">
      <div class="c-thumb-wrapper" :class="{ 'm-default-bg': !video }">
        <Spin v-show="loading" fix>
          <Icon type="ios-loading" size="30" class="c-fix-loading" />
          <span>上传中...</span>
        </Spin>
        <div class="c-alt-upload" :class="{ 'c-hide-upload': Boolean(video) }">
          <div class="c-upload-btns">
            <Button type="primary" @click="$emit('on-select', { name, width, height, size, type })">{{ btnText }}</Button>
            <Upload action="" :before-upload="preUpload">
              <Button>本地上传</Button>
            </Upload>
          </div>
          <div class="c-upload-txt">
            <span>{{ description }}规格：{{ width }}x{{ height }}</span>
            <span>{{ description }}大小：{{ size | smartSize }}</span>
            <span>支持类型：{{ format | formatType }}</span>
          </div>
        </div>
        <video v-if="video" :src="src" :class="{ 'vertical-img': vertical }" :style="setWrapperWidth">您的浏览器不支持 video 标签</video>
      </div>
    </div>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixins from './mixins'
import mixinVerify from './mixin-verify'
import { uploadLocalVideo } from '@/api/baidu.model'
export default {
  name: 'cVideo',
  mixins: [mixins, mixinVerify],
  props: {
    name: {
      type: String
    },
    type: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: [String, Number]
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    size: {
      type: Number
    },
    format: {
      type: Array,
      default() {
        return ['mp4', 'mov']
      }
    },
    required: {
      type: Boolean
    },
    verify: {
      type: Boolean
    },
    source: {
      type: Array
    }
  },
  computed: {
    video: {
      get() {
        return this.value || 0
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    src() {
      const index = this.source.findIndex((ret) => ret.videoid === this.video)
      return index < 0 ? '' : this.source[index].finalUrl
    },
    vertical() {
      return this.height >= this.width
    },
    setWrapperWidth() {
      const width = (148 * this.width) / this.height
      return { width: `${parseInt(width)}px` }
    },
    btnText() {
      return this.image ? `更新${this.description}` : `选择${this.description}`
    }
  },
  methods: {
    uploadFile(file) {
      const params = {
        account: this.$store.state.Baidu.account,
        width: this.width,
        height: this.height,
        file
      }
      this.loading = true
      // 上传尺寸后台判断
      uploadLocalVideo(params)
        .then((data) => {
          this.loading = false
          if (data) this.$emit('on-upload', { type: this.type, name: this.name, size: this.size, data })
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error({
            closable: true,
            duration: 5,
            content: err
          })
        })
    }
  },
  data() {
    return {
      loading: null
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-video {
  position: relative;
  z-index: 998;
  height: 148px;
  min-width: 260px;

  .c-thumb {
    width: inherit;
    height: inherit;

    .m-default-bg {
      height: inherit;
      background-color: #e8e8e8;
    }

    .c-thumb-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 9;

      video {
        width: 100%;
        height: 100%;
        display: block;

        &.vertical-img {
          margin: 0 auto;
        }
      }
    }

    .c-alt-upload {
      width: 100%;
      height: 100%;
      padding: 0 12px;
      position: absolute;
      z-index: 7;
      top: 0;
      left: 0;
      text-align: center;

      .c-upload-btns {
        padding: 22px 0px 12px;
        display: flex;
        justify-content: center;
      }

      .c-upload-txt {
        padding: 6px 12px;

        span {
          display: block;
          line-height: 1.4;
        }
      }
    }

    .c-hide-upload {
      opacity: 0;

      &:hover {
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.6);

        .c-upload-txt {
          color: #fff;
        }
      }
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -16px;
    color: #ff4400;
  }

  .c-fix-loading {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
